/** Синхрон с ``TG_MONITORING_EMPLOYEE_POSITIONS`` в api/utils/employee_positions.py */
export const TG_MONITORING_POSITIONS = new Set(['Zam', 'Manager', 'OperationalDirector'])

export function normalizedPositionCanTgMonitoring(normalized: string | null | undefined): boolean {
  const n = (normalized || '').trim()
  return !!n && TG_MONITORING_POSITIONS.has(n)
}
